import React from "react";
import { Button } from "@material-ui/core";
import errorImg from "../../../../assets/error_red_exclamation.svg";

interface ErrorInCreatingAppointmentProps {
  onClose: () => void;
  errorText: string;
}

const ErrorInCreatingAppointment: React.FC<ErrorInCreatingAppointmentProps> = ({
  onClose,
  errorText,
}) => {
  return (
    <div
      className="pld-screen pld-method-container"
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
      }}
    >
      {/* ERROR IMAGE */}
      <div style={{ marginTop: "25px" }}>
        <img src={errorImg} alt="error" height="80px" />
      </div>

      {/* NOTE BOX */}
      <div className="pld-note-container" style={{ marginTop: "25px" }}>
        <div className="pld-note-box">
          <span className="pld-bold">Error in creating appointment </span>
        </div>
      </div>

      <div style={{ marginTop: "10px" }}>{errorText}</div>

      {/* BUTTON */}
      <div className="pld-center" style={{ marginTop: "10px" }}>
        <Button className="zy-btn-orange pld-main-btn" onClick={onClose}>
          Okay
        </Button>
      </div>
    </div>
  );
};

export default ErrorInCreatingAppointment;
